/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RPublicIdRouteImport } from './routes/r.$publicId'
import { Route as RPublicIdIndexRouteImport } from './routes/r.$publicId.index'
import { Route as RPublicIdTrackingRouteImport } from './routes/r.$publicId.tracking'
import { Route as RPublicIdSigninRouteImport } from './routes/r.$publicId.signin'
import { Route as RPublicIdOnRampRouteImport } from './routes/r.$publicId.on-ramp'
import { Route as RPublicIdKycRouteImport } from './routes/r.$publicId.kyc'
import { Route as RPublicIdConsumeRouteImport } from './routes/r.$publicId.consume'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RPublicIdRoute = RPublicIdRouteImport.update({
  id: '/r/$publicId',
  path: '/r/$publicId',
  getParentRoute: () => rootRouteImport,
} as any)
const RPublicIdIndexRoute = RPublicIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RPublicIdRoute,
} as any)
const RPublicIdTrackingRoute = RPublicIdTrackingRouteImport.update({
  id: '/tracking',
  path: '/tracking',
  getParentRoute: () => RPublicIdRoute,
} as any)
const RPublicIdSigninRoute = RPublicIdSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => RPublicIdRoute,
} as any)
const RPublicIdOnRampRoute = RPublicIdOnRampRouteImport.update({
  id: '/on-ramp',
  path: '/on-ramp',
  getParentRoute: () => RPublicIdRoute,
} as any)
const RPublicIdKycRoute = RPublicIdKycRouteImport.update({
  id: '/kyc',
  path: '/kyc',
  getParentRoute: () => RPublicIdRoute,
} as any)
const RPublicIdConsumeRoute = RPublicIdConsumeRouteImport.update({
  id: '/consume',
  path: '/consume',
  getParentRoute: () => RPublicIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/r/$publicId': typeof RPublicIdRouteWithChildren
  '/r/$publicId/consume': typeof RPublicIdConsumeRoute
  '/r/$publicId/kyc': typeof RPublicIdKycRoute
  '/r/$publicId/on-ramp': typeof RPublicIdOnRampRoute
  '/r/$publicId/signin': typeof RPublicIdSigninRoute
  '/r/$publicId/tracking': typeof RPublicIdTrackingRoute
  '/r/$publicId/': typeof RPublicIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/r/$publicId/consume': typeof RPublicIdConsumeRoute
  '/r/$publicId/kyc': typeof RPublicIdKycRoute
  '/r/$publicId/on-ramp': typeof RPublicIdOnRampRoute
  '/r/$publicId/signin': typeof RPublicIdSigninRoute
  '/r/$publicId/tracking': typeof RPublicIdTrackingRoute
  '/r/$publicId': typeof RPublicIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/r/$publicId': typeof RPublicIdRouteWithChildren
  '/r/$publicId/consume': typeof RPublicIdConsumeRoute
  '/r/$publicId/kyc': typeof RPublicIdKycRoute
  '/r/$publicId/on-ramp': typeof RPublicIdOnRampRoute
  '/r/$publicId/signin': typeof RPublicIdSigninRoute
  '/r/$publicId/tracking': typeof RPublicIdTrackingRoute
  '/r/$publicId/': typeof RPublicIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/r/$publicId'
    | '/r/$publicId/consume'
    | '/r/$publicId/kyc'
    | '/r/$publicId/on-ramp'
    | '/r/$publicId/signin'
    | '/r/$publicId/tracking'
    | '/r/$publicId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/r/$publicId/consume'
    | '/r/$publicId/kyc'
    | '/r/$publicId/on-ramp'
    | '/r/$publicId/signin'
    | '/r/$publicId/tracking'
    | '/r/$publicId'
  id:
    | '__root__'
    | '/'
    | '/r/$publicId'
    | '/r/$publicId/consume'
    | '/r/$publicId/kyc'
    | '/r/$publicId/on-ramp'
    | '/r/$publicId/signin'
    | '/r/$publicId/tracking'
    | '/r/$publicId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  RPublicIdRoute: typeof RPublicIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$publicId': {
      id: '/r/$publicId'
      path: '/r/$publicId'
      fullPath: '/r/$publicId'
      preLoaderRoute: typeof RPublicIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$publicId/': {
      id: '/r/$publicId/'
      path: '/'
      fullPath: '/r/$publicId/'
      preLoaderRoute: typeof RPublicIdIndexRouteImport
      parentRoute: typeof RPublicIdRoute
    }
    '/r/$publicId/tracking': {
      id: '/r/$publicId/tracking'
      path: '/tracking'
      fullPath: '/r/$publicId/tracking'
      preLoaderRoute: typeof RPublicIdTrackingRouteImport
      parentRoute: typeof RPublicIdRoute
    }
    '/r/$publicId/signin': {
      id: '/r/$publicId/signin'
      path: '/signin'
      fullPath: '/r/$publicId/signin'
      preLoaderRoute: typeof RPublicIdSigninRouteImport
      parentRoute: typeof RPublicIdRoute
    }
    '/r/$publicId/on-ramp': {
      id: '/r/$publicId/on-ramp'
      path: '/on-ramp'
      fullPath: '/r/$publicId/on-ramp'
      preLoaderRoute: typeof RPublicIdOnRampRouteImport
      parentRoute: typeof RPublicIdRoute
    }
    '/r/$publicId/kyc': {
      id: '/r/$publicId/kyc'
      path: '/kyc'
      fullPath: '/r/$publicId/kyc'
      preLoaderRoute: typeof RPublicIdKycRouteImport
      parentRoute: typeof RPublicIdRoute
    }
    '/r/$publicId/consume': {
      id: '/r/$publicId/consume'
      path: '/consume'
      fullPath: '/r/$publicId/consume'
      preLoaderRoute: typeof RPublicIdConsumeRouteImport
      parentRoute: typeof RPublicIdRoute
    }
  }
}

interface RPublicIdRouteChildren {
  RPublicIdConsumeRoute: typeof RPublicIdConsumeRoute
  RPublicIdKycRoute: typeof RPublicIdKycRoute
  RPublicIdOnRampRoute: typeof RPublicIdOnRampRoute
  RPublicIdSigninRoute: typeof RPublicIdSigninRoute
  RPublicIdTrackingRoute: typeof RPublicIdTrackingRoute
  RPublicIdIndexRoute: typeof RPublicIdIndexRoute
}

const RPublicIdRouteChildren: RPublicIdRouteChildren = {
  RPublicIdConsumeRoute: RPublicIdConsumeRoute,
  RPublicIdKycRoute: RPublicIdKycRoute,
  RPublicIdOnRampRoute: RPublicIdOnRampRoute,
  RPublicIdSigninRoute: RPublicIdSigninRoute,
  RPublicIdTrackingRoute: RPublicIdTrackingRoute,
  RPublicIdIndexRoute: RPublicIdIndexRoute,
}

const RPublicIdRouteWithChildren = RPublicIdRoute._addFileChildren(
  RPublicIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  RPublicIdRoute: RPublicIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
